import BankBalance from '../../../../assets/images/BankBalance.png';
import { Chart } from "react-google-charts";
import { useEffect, useState } from 'react';
import { managementFinanceAPI } from '../../../../api/managementFinanceAPI';
import { toast } from 'react-toastify';
import AllPcode from '../../../allPcode';
import usePcode from '../../../../common/hooks/usePcode';

const options = {
    chartArea: {
        width: "90%",
    },
    is3D: true,

};

export default function BankBalanceModal() {
    const [transactionDetails, setTransactionDetails] = useState([]);
    const [showChart, setShowChart] = useState(false);
    const { loggedPcode } = usePcode();
    const [selectedPcode, setSelectedPcode] = useState(loggedPcode);


    useEffect(() => {
        const handleShowChart = () => {
            setShowChart(true);
        };

        const modalElement = document.getElementById("BankBalance");
        if (modalElement) {
            modalElement.addEventListener("shown.bs.modal", handleShowChart);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener("shown.bs.modal", handleShowChart);
            }
        };
    }, []);

    useEffect(() => {
        handleBankBalanceDetails(selectedPcode);
    }, [selectedPcode]);

    const handleBankBalanceDetails = (selectedPcode) => {
        managementFinanceAPI.getBankBalance(selectedPcode).then((data) => {
            setTransactionDetails(data);
        }).catch((err) => {
            toast.error(err.message);
        });
    }

    const chartData = [['Account Name', 'Balance']];
    transactionDetails.forEach(item => {
        chartData.push([item.accountName, parseFloat(item.balance)])
    });

    return (
        <>
            <a type="button" className='border border-0 rounded rounded-5' data-bs-toggle="modal" data-bs-target="#BankBalance">
                <img src={BankBalance} class="card-img-top rounded rounded-5" alt="BankBalance" />
            </a>
            <div className="modal fade" id="BankBalance" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Bank Balance</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body w-100 h-100 bg-light">
                            <div className="row">
                                <div className="col-0 col-sm-0 col-md-0 col-lg-9 col-xl-9 col-xxl-9">
                                    <div className="input-group input-group-sm">
                                        <AllPcode setSelectedPcode={setSelectedPcode} loggedPcode={loggedPcode} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3">
                                </div>
                                {showChart ? (
                                    transactionDetails.length > 0 ? (
                                        <Chart
                                            chartType="PieChart"
                                            style={{ marginTop: "20px", marginBottom: "20px", width: "100%", height: "400px" }}
                                            data={chartData}
                                            options={options}
                                        />
                                    ) : (
                                        <h3>No Data Available</h3>
                                    )
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}